import React, { useEffect, useMemo, useState } from 'react'
import SearchField from '../components/SearchField'
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, InputAdornment, Typography } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { toFarsiDigits } from './utils'

/** تبدیل ارقام فارسی/عربی به انگلیسی برای جستجوی مطمئن */
export function toEnDigits(s) {
  return String(s == null ? '' : s)
    .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
}

/**
 * فیلتر مشترک جدولهای گزارش (جستجوی زنده + فیلتر سال مالی)
 * extract = { search: row => [مقادیر متنی برای جستجو], year: row => عدد سال (اختیاری) }
 * خروجی: { search,setSearch, year,setYear, years, filtered }
 */
export function useReportFilter(rows, extract, { debounceMs = 400 } = {}) {
  const [search, setSearch] = useState('')
  const [year, setYear] = useState('')
  const [debounced, setDebounced] = useState('')

  useEffect(() => {
    const t = setTimeout(() => setDebounced(search), debounceMs)
    return () => clearTimeout(t)
  }, [search, debounceMs])

  const years = useMemo(() => {
    if (!extract || !extract.year) return []
    const set = new Set();
    (rows || []).forEach((r) => {
      const y = extract.year(r)
      if (y !== undefined && y !== null && String(y).trim() !== '') set.add(String(y).trim())
    })
    return [...set].sort((a, b) => Number(toEnDigits(b) || 0) - Number(toEnDigits(a) || 0))
  }, [rows, extract])

  const filtered = useMemo(() => {
    const list = rows || []
    const q = toEnDigits(debounced).trim()
    const y = toEnDigits(year).trim()
    if (!q && !y) return list
    return list.filter((r) => {
      if (y && extract.year && String(toEnDigits(extract.year(r)).trim()) !== y) return false
      if (!q) return true
      const values = extract.search(r) || []
      return values.some((v) => v !== undefined && v !== null && toEnDigits(v).includes(q))
    })
  }, [rows, debounced, year, extract])

  return { search, setSearch, year, setYear, years, filtered }
}

/** نوارِ فیلتر بالای جدول — جستجو + انتخاب سال مالی */
export const ReportToolbar = ({ search, setSearch, year, setYear, years, rowsCount, filteredCount }) => {
  if (!years || !years.length) return null
  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
      <SearchField
        size="small" variant="outlined"
        placeholder="جستجو در شماره، مبلغ، شرح و ... (همان لحظه)"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ minWidth: 260, background: '#fff', borderRadius: 8 }}
      />
      <FormControl size="small" variant="outlined" style={{ minWidth: 130 }}>
        <InputLabel>سال مالی</InputLabel>
        <Select value={year} onChange={(e) => setYear(e.target.value)} label="سال مالی">
          <MenuItem value="">همه سالها</MenuItem>
          {years.map((y) => (
            <MenuItem key={y} value={y}>{toFarsiDigits(y)}</MenuItem>
          ))}
        </Select>
      </FormControl>
      {rowsCount !== undefined && filteredCount !== undefined && filteredCount !== rowsCount && (
        <Typography style={{ fontSize: 11.5, color: '#7a80a3' }}>
          {toFarsiDigits(filteredCount)} از {toFarsiDigits(rowsCount)} ردیف
        </Typography>
      )}
    </Box>
  )
}
